import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { history } from "_helpers/history";
import { withTranslation } from "react-i18next";
import { useTranslation } from "react-i18next";
import "../../auth/index.scss";
import {Button} from "antd";

import NavbarNoLogin from "../../../components/Header/Navbars/NavbarNoLogin";
import LogoComillas from "assets/img/logo-comillas-blanco.png";
import Footer from "../../../components/Footer/footer";

function IndexPage(props) {
    useDispatch();
    const { t } = useTranslation();
    return (
    <>
      <div className={"headerNoRegister home"}>
        <NavbarNoLogin className="menuNavHome" showItems={false}/>
        <div className={"containerDesc boxed"}>
          <div className={"container-text"}>
            <p className={"info"}>La página web para el registro de Orientadores y Tutores en el Proyecto Orión, se encuentra deshabilitada, para este curso 2002-2023. Estamos trabajando para mejorar los servicios que ofrece y actualizando su
                diseño, esta nueva versión estará disponible a partir de enero del 2023. Si quieres saber más sobre la nueva plataforma y deseas formar parte este curso de la red de centros del Proyecto Orión puedes contactar
                con nosotros en: ai.orion@comillas.edu<br/><br/>
                Durante este curso, la web de alumnos usuarios en la versión actual https://web.upcomillas.es/myvip/alumnos/ se podrá seguir utilizando sólo mediante la opción de “Usuario invitado”.<br/><br/>
                Muchas gracias por tu disponibilidad y ayuda.<br/><br/>
                Equipo Proyecto Orión</p>
          </div>
          <img className={"main-logo"} src={LogoComillas} alt={""} width={343} height={246}/>
        </div>
      </div>
      <Footer />
    </>
  );
}
export default  withTranslation()(IndexPage);
